<template>
  <div class="detail">
    <img class="img" src="@/assets/img/detail-c1.png" alt />
   <div class="swiper-container">
    <swiper :options="swiperOption" ref="mySwiper" >
      <swiper-slide v-for="(url, index) in bannerList" :key="index" class="swiper-slide"> 
        <img class="swiper-img" :src="url" alt />
        </swiper-slide>
         <swiper-slide class="swiper-slide"> 
        <video id="bannerVideo" class="video-js" :autoplay='false' loop='loop' muted='muted'>
            <source :src="bannerVideo" type="video/mp4" />
          </video>
          </swiper-slide>
      <div class="swiper-pagination" slot="pagination">
        <!-- <div style="text-align: right;">
                       <div style="display: inline-block;margin-right: 10px;border-radius: 4px;padding: 4px 6px;background: #eee;color: black;">${current}/${total}</div>
                 </div> -->
      </div>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
  </div>
    <!-- <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <video id="bannerVideo" class="video-js">
            <source :src="bannerVideo" type="video/mp4" />
          </video>
        </div>
        <div class="swiper-slide" v-for="(url, index) in bannerList" :key="index">
          <img class="swiper-img" :src="url" alt />
          
        </div>
         <div class="swiper-slide">Slide 1</div>
        <div class="swiper-slide">Slide 2</div>
        <div class="swiper-slide">Slide 3</div>
      </div>
      <div class="swiper-pagination"></div>
    </div> -->
    <img class="img" :src="imgs.detail_pic1" alt @click="onGetCouponsClick" />
    <div class="video-c">
      <video id="myVideo1" class="video-js">
        <source :src="videoUrl" type="video/mp4" />
      </video>
    </div>
    <img class="img" :src="imgs.detail_pic2" alt />
    <img class="img" :src="imgs.detail_pic3" alt />
    <a class="tel" href="tel:13757178477">
      <img src="@/assets/img/tel.png" alt />
    </a>
  </div>
</template>

<script>
import API from "./api";
// import Swiper from "swiper";
import { Toast } from "mint-ui";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'
// import 'swiper/css/bundle';
  // Import Swiper styles
  // import 'swiper/css';
export default {
  beforeRouteLeave(to, from, next) {
    this.videoList.forEach(video => {
      video && video.dispose();
    });
    next(); //一定不要忘记写
  },
components: {
    swiper,
    swiperSlide
  },
  computed:{
     swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  data() {
    return {
      bannerVideo: "",
      bannerList: [],
      imgs: {},
      videoUrl: "",
      videoList: [],
      swiperOption: {
        loop: false,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true ,//允许分页点击跳转
            }
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      }
    }
  },
  methods: {
    get_pic_banner_video() {
      API.get_pic(
        {
          type: 9
        },
        res => {
          if (res && res.code) {
            this.bannerVideo = res.data.activity_detail_video;
            this.$nextTick(() => {
              this.initVideo("bannerVideo", false);
            });
          }
        }
      );
    },
    get_pic_banner() {
      API.get_pic(
        {
          type: 6
        },
        res => {
          if (res && res.code) {
            let list = [];
            Object.keys(res.data).forEach(key => {
              if (res.data[key]) {
                list.push(res.data[key]);
              }
            });
            this.$set(this, "bannerList", list);
           
           
          }
        }
      );
    },
    get_pic_imgs() {
      API.get_pic(
        {
          type: 7
        },
        res => {
          if (res && res.code) {
            this.$set(this, "imgs", res.data);
          }
        }
      );
    },
    get_pic_video() {
      API.get_pic(
        {
          type: 8
        },
        res => {
          if (res && res.code) {
            this.videoUrl = res.data.detail_video;
            this.$nextTick(() => {
              this.initVideo("myVideo1", 'muted');
            });
          }
        }
      );
    },
    // initSwiper() {
    //   this.$nextTick(() => {
    //     new Swiper(".swiper-container", {
    //       loop: true,
         
    //       autoplay: {
    //         delay: 3000,
    //         disableOnInteraction: false
    //       },
    //       pagination: {
    //         el: ".swiper-pagination",
    //         type: "custom",
    //         renderCustom: function(swiper, current, total) {
    //           return `<div style="text-align: right;">
    //                     <div style="display: inline-block;margin-right: 10px;border-radius: 4px;padding: 4px 6px;background: #eee;color: black;">${current}/${total}</div>
    //                   </div>`;
    //         }
    //       }
    //     });
    //   });
    // },
    initVideo(id, bool) {
      //初始化视频方法
      let video = this.$video(
        id,
        {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: bool,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto"
        });
      this.videoList.push(video);
    },
    onGetCouponsClick() {
      API.activity(
        {
          phone: this.$store.state.phone
        },
        res => {
          if (res.code == 1) {
            this.$router.push({
              name: "coupons",
              params: {}
            });
          } else {
            Toast({
              message: res.msg,
              iconClass: "icon icon-error"
            });
          }
        }
      );
    }
  },
  mounted() {
    this.get_pic_banner_video();
    this.get_pic_banner();
    this.get_pic_imgs();
    this.get_pic_video();
  }
};
</script>

<style scoped lang="scss">
.detail {
  width: 7.5rem;
  .img {
    width: 7.5rem;
  }
  .swiper-container {
    width: 7.5rem;
    height: 7.11rem;
    .video-js {
      width: 7.5rem;
      height: 7.11rem;
      /deep/.vjs-big-play-button {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .swiper-img {
      width: 7.5rem;
      height: 7.11rem;
    }
    .swiper-wrapper {
      text-align: right;
    
    }
  }
  .video-c {
    width: 7.5rem;
    height: 4.2rem;
    .video-js {
      width: 7.5rem;
      height: 4.2rem;
      /deep/.vjs-big-play-button {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .tel {
    width: 0.9rem;
    height: 0.9rem;
    position: fixed;
    right: 0.4rem;
    bottom: 0.8rem;
    img {
      width: 0.9rem;
      height: 0.9rem;
    }
  }
}

.swiper-slide{
  width: 100%;
  line-height: auto;
  background: yellowgreen;
  color: #000;
  
  text-align: center;
}
</style>
